import React, { useCallback, useState } from 'react'
import { Alert } from 'components'
import { useAlert } from 'components/Alerts/hooks'
import { AutoComplete } from 'components/Form'
import { getStatusTypesFetch } from 'store/middlewares/assessment.crud'
import { useQuery } from '@tanstack/react-query'
import qc from 'keys/queryClient'

// שכבת UI משותפת ל"מדוע להחזיר לביצוע חוזר?" ול"מה סיבת התקיעות?" -
// שתיהן בוחרות StatusType מתוך אותה טבלה, רק עם category שונה.
// כל קריאה מביאה alertKey/title/category משלה, ומחליטה בעצמה מה קורה באישור (onConfirm).
const StatusTypeReasonAlert = ({ alertKey, title, category, onConfirm, confirmLoading }) => {
    const [statusType, setStatusType] = useState(null)
    const { setAlerts } = useAlert()

    const handleClose = useCallback(() => {
        setStatusType(null)
        setAlerts(alertKey, false)
    }, [alertKey])

    const statusTypes = useQuery({
        queryKey: [qc.statusTypes, category],
        queryFn: async () => {
            const { data } = await getStatusTypesFetch(category)
            return data
        }
    })

    const confirm = useCallback(async () => {
        await onConfirm(statusType)
        handleClose()
    }, [onConfirm, statusType])

    const footerActions = React.useMemo(
        () => [
            { label: "ביטול", color: "thirdly4", action: handleClose },
            { label: "אישור", color: "thirdly", action: confirm, loading: confirmLoading, disabled: confirmLoading || !statusType }
        ], [confirm, confirmLoading, statusType]
    )

    return (
        <Alert
            systemUI
            title={title}
            footerActions={footerActions}
            handleAlert={handleClose}
        >
            <AutoComplete
                options={statusTypes.data || []}
                placeholder="בחר סוג שגיאה"
                fullWidth
                input={{
                    value: statusType,
                    onChange: setStatusType
                }}
                labelKey="label"
            />
        </Alert>
    )
}

export default StatusTypeReasonAlert
